import { render } from "./NewTDACartItem.vue?vue&type=template&id=5800c53e&scoped=true"
import script from "./NewTDACartItem.vue?vue&type=script&lang=js"
export * from "./NewTDACartItem.vue?vue&type=script&lang=js"

import "./NewTDACartItem.vue?vue&type=style&index=0&id=5800c53e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5800c53e"]])

export default __exports__